var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdomFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_3520_8501)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30758 6.25903C2.05077 7.89422 1.10308 9.77891 0.55127 11.8263H8.87489L3.30758 6.25903Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.449 11.8263C30.8972 9.77891 29.9494 7.89422 28.6927 6.25903L23.1255 11.8263H31.449Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.55127 20.1741C1.10314 22.2214 2.05083 24.1061 3.30758 25.7413L8.87471 20.1741H0.55127Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7413 3.30764C24.1061 2.05083 22.2215 1.10314 20.1741 0.55127V8.87483L25.7413 3.30764Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25903 28.6926C7.89422 29.9494 9.77891 30.8971 11.8263 31.449V23.1255L6.25903 28.6926Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8262 0.55127C9.77885 1.10314 7.89416 2.05083 6.25903 3.30758L11.8262 8.87477V0.55127Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1741 31.449C22.2214 30.8971 24.1061 29.9494 25.7413 28.6927L20.1741 23.1255V31.449Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1255 20.1741L28.6927 25.7413C29.9494 24.1062 30.8972 22.2214 31.449 20.1741H23.1255Z",
    fill: "#0052B4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2926 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2926 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z",
    fill: "#D80027"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 20.1739L27.3136 27.3136C27.642 26.9854 27.9552 26.6422 28.2541 26.2865L22.1415 20.1738H20.1738V20.1739Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 20.1741H11.826L4.68628 27.3138C5.01453 27.6421 5.35772 27.9554 5.71347 28.2543L11.8261 22.1415V20.1741Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 11.8262V11.8261L4.68635 4.68628C4.35797 5.01453 4.04472 5.35772 3.74585 5.71347L9.85854 11.8262L11.8261 11.8262Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 11.8262L27.3136 4.68629C26.9854 4.35791 26.6422 4.04466 26.2865 3.74585L20.1738 9.85854V11.8262Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3520_8501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdomFlag);
export default __webpack_public_path__ + "static/media/united-kingdom-flag.c88824d16765432f0f59812ec416dd17.svg";
export { ForwardRef as ReactComponent };